import React from "react";

import Crossword from "./Crossword";

const App = () => <Crossword />;

export default App;
